module.exports = __webpack_public_path__ + "static/linkToFanPageFacebook.91300d2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/linkToFanPageFacebook.png
// module id = 538
// module chunks = 227772203984691